import React from "react";
import { cloneElement, Children } from "react";

import get from "lodash/get";
import orderBy from "lodash/orderBy";

import { ArrayField } from "react-admin";

export const SortedArrayField = ({
  record,
  source,
  sort,
  children,
  ...rest
}) => {
  const items = get(record, source, []); // Safely get nested property

  if (!Array.isArray(items)) {
    return null; // Handle case where source is not an array
  }

  // Apply lodash orderBy for sorting
  const sortedItems = sort
    ? orderBy(
        items,
        [(item) => get(item, sort.field)],
        [sort.order.toLowerCase()]
      )
    : items;

  // Wrap sorted data in a custom record object
  const sortedRecord = { ...record, [source]: sortedItems };

  return (
    <ArrayField source={source} record={sortedRecord} {...rest}>
      {cloneElement(Children.only(children))}
    </ArrayField>
  );
};
